import React from "react";

interface IProps {
    showRecommended: boolean;
    recommended: boolean | null;
}

interface IState {}

// TODO(ssr, LEVEL 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to 30 LOC, simple conditional rendering, and no state or lifecycle methods.
export class ReviewRecommended extends React.PureComponent<IProps, IState> {
    render() {
        if (!this.props.showRecommended) {
            return null;
        }
        if (this.props.recommended === null) {
            return null;
        }

        const reviewMsg = this.props.recommended
            ? "YES, I do recommend this product!"
            : "NO, I do not recommend this product";

        return (
            <div>
                <strong>{reviewMsg}</strong>
            </div>
        );
    }
}
